import React from 'react'
import { Box } from 'rebass'
import 'flickity/dist/flickity.min.css'

import Layout from '../components/layout'
import Header from '../components/Header'
import Container from '../components/Container'
import TopHero from '../sections/TopHero'
import CoverSpread from '../sections/CoverSpread'
import PreorderUpper from '../sections/PreorderUpper'
import PreorderLower from '../sections/PreorderLower'
import BookPreview from '../sections/BookPreview'
import Spotify from '../sections/Spotify'
import Links from '../sections/Links'
import PictureSlideshow from '../sections/PictureSlideshow'
import Quotes from '../sections/Quotes'
import BrandFooter from '../sections/BrandFooter'

const IndexPage = () => {
  return (
    <Layout>
      <Header />
      <Box as="section" id="hero">
        <Container zebra>
          <TopHero />
        </Container>
      </Box>
      <Box as="section" bg="white" id="cover">
        <Container>
          <CoverSpread />
        </Container>
      </Box>
      <Box as="section" id="slideshow">
        <Container>
          <PictureSlideshow />
        </Container>
      </Box>
      <Box as="section" bg="white" id="preorder-upper">
        <Container>
          <PreorderUpper />
        </Container>
      </Box>
      <Box
        as="section"
        css={{ position: 'relative' }}
        bg="transparent"
        id="preview"
      >
        <Container zebra>
          <BookPreview />
        </Container>
      </Box>
      <Box as="section" bg="white" id="quotes" py={[48, 96]}>
        <Container padded>
          <Quotes />
        </Container>
      </Box>
      <Box as="section" id="playlist" py={[48, 96]} px={[16, 0]}>
        <Container padded>
          <Spotify />
        </Container>
      </Box>
      <Box
        as="section"
        bg="white"
        id="preorder-lower"
        pb={[48, 96]}
        pt={[48, 96]}
      >
        <Container>
          <PreorderLower />
        </Container>
      </Box>
      <Box as="section" id="links" py={36}>
        <Container>
          <Links />
        </Container>
      </Box>
      <Container>
        <Box bg="white" css={{ height: 3 }} />
      </Container>
      <Box as="section" id="footer" py={[48]}>
        <Container padded>
          <BrandFooter />
        </Container>
      </Box>
    </Layout>
  )
}

export default IndexPage
